export default [
  {
    title: 'Tableau de bord',
    route: 'dashboard',
    icon: 'HomeIcon',
  },
  {
    title: 'Rechercher un colis',
    icon: 'SearchIcon',
    route: 'orders-search-history',
  },
  {
    title: 'État de synchronisation',
    icon: 'RefreshCwIcon',
    route: 'sync-state-orders',
  },
  {
    title: 'Colis',
    icon: 'BoxIcon',
    children: [
      {
        title: 'Liste des colis',
        route: 'orders-index',
      },
      {
        title: 'Réception Centre',
        route: 'order-status',
        icon: 'TargetIcon',
      },
      {
        title: 'Échange',
        route: 'echange-order',
        icon: 'TargetIcon',
      },
      {
        title: 'Ajouter Extra',
        route: 'extra-fees',
        icon: 'PlusCircleIcon',
      },
    ],
  },
  {
    title: 'Bordereau',
    icon: 'FileIcon',
    route: 'delivery-note-list',
  },
  {
    title: 'Pickup',
    icon: 'ShoppingCartIcon',
    route: 'pickup-list',
  },
  {
    title: 'Suivi sous-traitance',
    icon: 'ClipboardIcon',
    children: [
      {
        title: 'Liste des bons',
        route: 'manifests-list',
      },
      {
        title: 'Créer un bon',
        route: 'manifest-create',
      },
    ],
  },
  {
    title: 'Payment sous traitance',
    icon: 'DollarSignIcon',
    children: [
      {
        title: 'Liste des payments',
        route: 'payment-sous-traitance-list',
      },
      {
        title: 'Créer payment',
        route: 'payment-sous-traitance-create',
      },
    ],
  },
  {
    title: 'Inventaire',
    icon: 'ArchiveIcon',
    children: [
      {
        title: 'Scanner inventaire',
        route: 'inventory-dashboard',
      },
      {
        title: 'Historique inventaires',
        route: 'inventory-history',
      },
    ],
  },
  {
    title: 'Run sheet',
    icon: 'FilePlusIcon',
    children: [
      {
        title: 'Run sheet list',
        route: 'roadmap-list',
      },
      {
        title: 'Add run sheet',
        route: { name: 'roadmap-add' },
      },
    ],
  },
  {
    title: 'Débrief',
    icon: 'DollarSignIcon',
    children: [
      {
        title: 'Liste des débriefs',
        route: 'payment-list',
      },
      {
        title: 'Ajouter un débrief',
        route: 'payment-add',
      },
    ],
  },
  {
    title: 'Traitement anomalie',
    icon: 'FileMinusIcon',
    children: [
      {
        title: 'Scan traitement anomalie',
        route: { name: 'bon-retour-definitive-manager-scan' },
      },
      {
        title: 'Vérification',
        route: { name: 'bon-retour-definitive-verify' },
      },
    ],
  },
  {
    title: 'Retour fournisseur',
    icon: 'FileMinusIcon',
    children: [
      {
        title: 'Liste retour fournisseur',
        route: 'bon-retour-list',
      },
      {
        title: 'Retour fournisseur',
        route: { name: 'bon-retour-add' },
      },
    ],
  },
  {
    title: 'Retour inter-agence',
    icon: 'FileMinusIcon',
    children: [
      {
        title: 'Liste des retours inter-agence',
        route: 'bon-retour-list-inter-agence',
      },
      {
        title: 'Ajouter un retour inter-agence',
        route: { name: 'bon-retour-inter-agence-add' },
      },
    ],
  },
  {
    title: 'Bon de transfert',
    icon: 'ExternalLinkIcon',
    children: [
      {
        title: 'Réception Centre',
        route: 'reception-transfert',
        icon: 'TargetIcon',
      },
      {
        title: 'Liste des bons de transfert',
        route: 'bon-transfert-list',
      },
      {
        title: 'Ajouter un bon de transfert',
        route: { name: 'bon-transfert-add' },
      },
    ],
  },
  {
    title: "Manifeste d'échange",
    icon: 'RefreshCwIcon',
    children: [
      {
        title: "Liste des manifestes d'échange",
        route: 'exchange-manifest-list',
      },
      {
        title: "Créer un manifeste d'échange",
        route: 'exchange-manifest-create',
      },
    ],
  },
  {
    title: 'Liste livreurs',
    icon: 'UserCheckIcon',
    route: 'delivery-man-list',
  },
  {
    title: 'Liste expéditeurs',
    icon: 'UsersIcon',
    route: 'supplier-list',
  },
  {
    title: 'Support',
    icon: 'mdi-lifebuoy',
    children: [
      {
        title: 'Tickets de support',
        icon: 'HelpCircleIcon',
        route: 'SupportTicketList',
      },
      {
        title: 'Réclamations Livreur',
        icon: 'TruckIcon',
        route: 'support-driver-ticket-list',
      },
      {
        title: 'Demandes de nouvelle livraison',
        icon: 'TruckIcon',
        route: 'RedeliveryRequestList',
        meta: { requiresAdmin: true },
      },
      {
        title: 'Demandes de modification de prix',
        icon: 'DollarSignIcon',
        route: 'PriceChangeRequestList',
        meta: { requiresAdmin: true },
      },
    ],
  },
]
